import ClickableTableCell from 'Components/ClickableTableCell'
import CustomTablePagination from 'Components/CustomTablePagination'
import EnhancedTableHead from 'Components/EnhancedTableHead'
import NoWrapTableCell from 'Components/NoWrapTableCell'
import StyledTableRow from 'Components/StyledTableRow'
import { WithLoader } from 'Components/WithLoader'
import type {
  FetchZoneDefinitionListParams,
  ZoneDefinition
} from 'Services/ProductManagement/Features/ZoneDefinition/types'
import { ROWS_PER_PAGE_DEFAULT, SORT_ORDER_ASC } from 'Util/constants'
import { datetimeFormatter, showValueOrHyphen } from 'Util/formatters'
import { Paper, Table, TableBody, TableContainer } from '@mui/material'
import { t } from 'ttag'

interface ZoneDefinitionListProps {
  rows: ZoneDefinition[]
  isLoading: boolean
  params: FetchZoneDefinitionListParams
  handleRequestSort: (event: React.MouseEvent<unknown>, property: string) => void
  handleChangePage: (event: unknown, newPage: number) => void
  count: number
  page: number
  onRowClick: (id: string) => void
  selectedZoneDefinitionId: string | undefined
}

export function ZoneDefinitionList({
  rows,
  isLoading,
  params,
  handleRequestSort,
  handleChangePage,
  count,
  page,
  onRowClick,
  selectedZoneDefinitionId
}: Readonly<ZoneDefinitionListProps>) {
  const headCells = [
    {
      id: 'id',
      label: t`Identifier`,
      numeric: false,
      sortable: true,
      disablePadding: false
    },
    {
      id: 'modified_timestamp',
      label: t`Modified`,
      numeric: false,
      sortable: false,
      disablePadding: false
    },
    {
      id: 'created_timestamp',
      label: t`Created`,
      numeric: false,
      sortable: false,
      disablePadding: false
    }
  ]

  const orderPrefix = `${params.sort_order === SORT_ORDER_ASC ? '-' : ''}`
  const orderBy = `${orderPrefix}${params.sort_by}`

  return (
    <WithLoader loading={isLoading} rows={ROWS_PER_PAGE_DEFAULT} height={33}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size="small">
            <EnhancedTableHead
              orderBy={orderBy}
              headCells={headCells}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {rows?.map(row => {
                return (
                  <StyledTableRow
                    hover
                    tabIndex={-1}
                    key={row.id}
                    selected={selectedZoneDefinitionId === row.id}
                  >
                    <ClickableTableCell onClick={() => onRowClick(row.id)}>
                      {showValueOrHyphen(row.id)}
                    </ClickableTableCell>
                    <NoWrapTableCell title={datetimeFormatter(row.modified_timestamp)}>
                      {datetimeFormatter(row.modified_timestamp)}
                    </NoWrapTableCell>
                    <NoWrapTableCell title={datetimeFormatter(row.created_timestamp)}>
                      {datetimeFormatter(row.created_timestamp)}
                    </NoWrapTableCell>
                  </StyledTableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <CustomTablePagination count={count} page={page} onPageChange={handleChangePage} />
      </Paper>
    </WithLoader>
  )
}
